import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import configureStore from './store';
import App from './App';

// Load only required locales - should match Resources locales
import 'moment/locale/en-gb';
import 'moment/locale/en-au';
import 'moment/locale/bg';
import 'moment/locale/ru';
import 'moment/locale/de';

import '../theme/css/bootstrap.min.css';
import '../theme/fonts/style.css';
import '../theme/css/main.css';
import '../theme/css/main-responsive.css';
import '../theme/css/theme_light.css';
import '../theme/css/custom.css';
import '../theme/css/stats.css';

import '@fortawesome/fontawesome-svg-core/styles.css';

const store = configureStore();

ReactDOM.render(
	<Provider store={store}>
		<HelmetProvider>
			<App />
		</HelmetProvider>
	</Provider>
	, document.getElementById('root'));